module.exports = __webpack_public_path__ + "img/857cac7.jpg";